import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "nav-entry nav-entry__cart"
};
const _hoisted_2 = { class: "d-flex" };
const _hoisted_3 = { class: "icon-container" };
const _hoisted_4 = ["title"];
const _hoisted_5 = { class: "content" };
const _hoisted_6 = { class: "notify-badge" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_router_link = _resolveComponent("router-link");
    return (_ctx.$appHost.session?.features?.carts && _ctx.$store.getters['carts/hasRequest'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_router_link, {
                        to: '/checkout/' + _ctx.$store.getters['carts/requestID']
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", {
                                class: "icon",
                                title: _ctx.$t('client.Commerce.Carts.Requests')
                            }, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_component_g_icon, {
                                        width: "16",
                                        height: "16",
                                        src: "/assets/icons/question-lg.svg",
                                        style: { "margin-bottom": "2px" }
                                    })
                                ]),
                                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$store.getters['carts/requestTotalLines']), 1)
                            ], 8, _hoisted_4)
                        ]),
                        _: 1
                    }, 8, ["to"])
                ])
            ])
        ]))
        : _createCommentVNode("", true);
}
